import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateBranch from "./UpdateBranch";
import DeleteBranch from "./DeleteBranch";

const server_backend = config.API_URL;

const Branchs = ({ username }) => {
    const [BranchList, setBranchList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onBranchID, setOnBranchID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");

    useEffect(() => {
        const getBranchs = async () => {
            try {
                const response = await axios.get(`${server_backend}/branchs/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setBranchList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getBranchs();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getBranchs = async () => {
        try {
            const response = await axios.get(`${server_backend}/branchs/list`, headers);
            if (response.data.RES_CODE === "00") {
                setBranchList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterBranch = async () => {
        try {
            const response = await axios.get(`${server_backend}/branchs/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setBranchList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterBranch();
        }
    }, [filterBy, filterStatus, filterValue]);

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                {!isUpdating ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Branches List</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Branches</a></li>
                                        <li className="breadcrumb-item active">Branches List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <UpdateBranch username={username} onBranchID={onBranchID} onClose={CloseModal} getBranchs={getBranchs} />
                )}

                {!isUpdating && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="tasksList">
                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">All Branches</h5>
                                        <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                            <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <Link className="btn btn-danger add-btn" to="/create-branch">
                                                <i className="ri-add-line align-bottom me-1"></i> Create
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {filtersEnabled && (
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <div className="row g-3">
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        data-choices
                                                        data-choices-search-false
                                                        name="choices-single-default"
                                                        id="idFilterBy"
                                                        disabled={!filtersEnabled}
                                                        value={selectedFilter}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="suc_ID">ID</option>
                                                        <option value="name">Name</option>
                                                        <option value="city">City</option>
                                                        <option value="phone">Phone</option>
                                                        <option value="address">Address</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        data-choices
                                                        data-choices-search-false
                                                        name="choices-single-default"
                                                        id="idFilterStatus"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        <option value={1}>ACTIVATED</option>
                                                        <option value={2}>DISABLED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="search-box">
                                                    <input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder="Search for tasks or something..."
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterValueChange}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                )}

                                <div className="card-body">
                                    <div
  className="table-responsive table-card mb-4"
  style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
>
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="th-hover" onClick={() => handleColumnClick("suc_ID")}>ID</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("name")}>Name</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("city")}>City</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("address")}>Address</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody className="list form-check-all">
                                                {BranchList.map((Branchs_L) => (
                                                    <tr key={Branchs_L.suc_ID}>
                                                        <th scope="row">
                                                            <div className="form-check">
                                                                {Branchs_L.suc_ID}
                                                            </div>
                                                        </th>
                                                        <td className="client_name">{Branchs_L.name}</td>
                                                        <td className="client_name">{Branchs_L.city}</td>
                                                        <td className="assignedto">
                                                            {Branchs_L.phone}
                                                        </td>
                                                        <td className="due_date">{Branchs_L.address}</td>
                                                        <td className="status">
                                                            <span className={`${Branchs_L.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                                {Branchs_L.status_name}
                                                            </span>
                                                        </td>
                                                        <td className="due_date">
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item edit">
                                                                    <Link
                                                                        type="button"
                                                                        onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnBranchID(Branchs_L.suc_ID);
                                                                        }}
                                                                        className="text-primary d-inline-block edit-item-btn"
                                                                    >
                                                                        <i className="ri-pencil-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" >
                                                                    <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                        DeleteBranch(Branchs_L.suc_ID, username, getBranchs)
                                                                    }}>
                                                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start">
                                        <div className="col-sm-6">
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Branchs;
